import { all, takeLatest } from 'redux-saga/effects';
import { GET_QUESTIONS } from '../../actions/questions';
import { getAllQustionsSaga } from './getQuestionsSagas';

function* questionsSagas() {
  yield all([yield takeLatest(GET_QUESTIONS.INITIATE, getAllQustionsSaga)]);
}

export default questionsSagas;
